
import React from "react";
import { Modal } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import * as handlers from "../../../../_redux/settings/settingsHandlers";

const DeleteWebhook = ({show, onHide, webhook}) => {

  const dispatch = useDispatch();

  const deleteWebhook = _ => {
    dispatch(handlers.deleteWebhook(webhook.id));
    onHide();
  }

  return (
    <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            <span className="svg-icon svg-icon-lg svg-icon-danger mr-3">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Github.svg")}/>
            </span>
            Delete Webhook
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body>

            <h5
                className="text-center font-weight-light"
            >
                Do you really want to delete <b>{`${webhook?.url ?? ""}`}</b>?
            </h5>
            
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate px-4"
            >
                Cancel
            </button>
            <> </>
            <button
                type="button"
                onClick={_ => deleteWebhook()}
                className="btn btn-danger btn-elevate px-5 ml-4"
            >
                Delete
            </button>
        </Modal.Footer>
      </Modal>

        );
}

export default DeleteWebhook;